import { create } from 'zustand';

import type { AccountStatsRow } from '../types/account-stats';

// Mirrors generalStatsCache (Instagram): keeps the last-loaded TikTok rows so
// returning to /analytics/general shows them instantly instead of re-fetching.
type TikTokGeneralStatsCacheState = {
  cacheKey: string | null;
  rows: AccountStatsRow[];
  setCache: (key: string, rows: AccountStatsRow[]) => void;
};

export const useTikTokGeneralStatsCache = create<TikTokGeneralStatsCacheState>((set) => ({
  cacheKey: null,
  rows: [],
  setCache: (key, rows) => set({ cacheKey: key, rows }),
}));
